import React, { FC } from "react";
import ClickAwayListener from "react-click-away-listener";
import { CloseButton } from "../../../CloseButton/CloseButton";
import { useHandleClickAway } from "../../../Hooks/useHandleClickAway";
import classNames from "classnames";

type AdditionalCheckModalProps = {
  onClose: () => void;
  isOpen: boolean;
  Modal: any;
  policy: string;
};

export const AdditionalCheckModal: FC<AdditionalCheckModalProps> = ({
  onClose,
  isOpen,
  Modal,
  policy,
}) => {
  const {
    handleMouseUp,
    handleMouseDown,
    handleClickAway,
    areaRef,
  } = useHandleClickAway(onClose);

  return (
    <Modal
      bodyOpenClassName={"ReactModal__Body--open"}
      overlayClassName="react-modal__overlay"
      className={classNames("react-modal__content react-modal__content--additional", { 'react-modal__content--opened': isOpen })}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <div className="confirm-modal__outer">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className="confirm-modal__inner my-2 p-2 pt-1 fs-5" ref={areaRef} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
            <CloseButton onClick={onClose} withWhiteBg />
            <div dangerouslySetInnerHTML={{ __html: policy }} />
          </div>
        </ClickAwayListener>
      </div>
    </Modal>
  );
};
